import {registerPlugin} from "@capacitor/core";
import {isAndroid} from "../FirebaseUtils";

const DiaryPlugin: any = registerPlugin("DiaryPlugin");

export function reportDiaryActivityCount(count: number): void {
  if (!isAndroid) return;
  DiaryPlugin.reportActivityCount({count}).catch(() => {
    // Plugin may not be ready during very early startup.
  });
}

export function setupDiaryActivityCountSync(getCount: () => number): any {
  if (!isAndroid) return null;

  reportDiaryActivityCount(getCount());

  return DiaryPlugin.addListener("activityCountRequested", () => {
    reportDiaryActivityCount(getCount());
  });
}
